<template>
  <div
    class="ws-flex"
    :class="[`gap-${gap}`,`flex-justify-${justify}`]"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "WsFlex",
  props: {
    gap: {
      type: Number,
      default: 0,
    },
    justify: {
      type: String,
      default: "0",
    },
  },
};
</script>